import React from "react";
import ReactModal from "react-modal";
import { ModalStyle, OverlayStyle } from "./Modal.styles";

const Modal = ({
  isOpen,
  children,
  onClose,
  shouldCloseOnOverlayClick = true,
  onAfterClose,
  animationDuration = 300,
  customOverlayStyles,
  customModalStyles,
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      onAfterClose={onAfterClose}
      className="_"
      overlayClassName="_"
      contentElement={(props) => (
        <ModalStyle
          {...props}
          style={customModalStyles}
          $animationDuration={animationDuration}
        >
          {children}
        </ModalStyle>
      )}
      overlayElement={(props, contentElement) => (
        <OverlayStyle
          {...props}
          $customStyles={customOverlayStyles}
          style={{
            backdropFilter: "blur(2.5px)",
            WebkitBackdropFilter: "blur(2.5px)",
            ...(customOverlayStyles || {}),
          }}
        >
          {contentElement}
        </OverlayStyle>
      )}
      shouldCloseOnEsc={shouldCloseOnOverlayClick}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    />
  );
};

export default Modal;
